// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const TotalPlays = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.totalPlays"
        description="Total plays."
        defaultMessage="Total Plays"
    />
);
TotalPlays.displayName = "TotalPlays";

export const PlaysContentName = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.playsContentName"
        description="Plays content name."
        defaultMessage="Plays"
    />
);
PlaysContentName.displayName = "PlaysContentName";

export const TotalPlaysTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.totalPlaysTooltip"
        description="Total plays tooltip."
        defaultMessage="The number of times your Lens(es) have been activated in the camera in Snapchat."
    />
);
TotalPlaysTooltip.displayName = "TotalPlaysTooltip";

export const TotalViews = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.totalViews"
        description="Total views."
        defaultMessage="Total Views"
    />
);
TotalViews.displayName = "TotalViews";

export const TotalViewsTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.totalViewsTooltip"
        description="Total views tooltip."
        defaultMessage="The sum of Lens views from direct snaps, story posts, and plays in Snapchat."
    />
);
TotalViewsTooltip.displayName = "TotalViewsTooltip";

export const ViewsContentName = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.viewsContentName"
        description="Views content name."
        defaultMessage="Views"
    />
);
ViewsContentName.displayName = "ViewsContentName";

export const TotalShares = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.totalShares"
        description="Total shares."
        defaultMessage="Total Shares"
    />
);
TotalShares.displayName = "TotalShares";

export const TotalSharesTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.totalSharesTooltip"
        description="Total shares tooltip."
        defaultMessage="The total number of times your Lens(es) have been shared in Snapchat."
    />
);
TotalSharesTooltip.displayName = "TotalSharesTooltip";

export const SharesContentName = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.sharesContentName"
        description="Shares content name."
        defaultMessage="Shares"
    />
);
SharesContentName.displayName = "SharesContentName";

export const TotalFavorites = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.totalFavorites"
        description="Total favorites."
        defaultMessage="Total Favorites"
    />
);
TotalFavorites.displayName = "TotalFavorites";

export const TotalFavoritesTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.totalFavoritesTooltip"
        description="Total favorites tooltip."
        defaultMessage="The total number of times your Lens(es) have been favorited in Snapchat."
    />
);
TotalFavoritesTooltip.displayName = "TotalFavoritesTooltip";

export const FavoritesContentName = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.favoritesContentName"
        description="Favorites content name."
        defaultMessage="Favorites"
    />
);
FavoritesContentName.displayName = "FavoritesContentName";

export const TotalPosts = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.totalPosts"
        description="Total posts."
        defaultMessage="Total Posts"
    />
);
TotalPosts.displayName = "TotalPosts";

export const TotalPostsTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.totalPostsTooltip"
        description="Total posts tooltip."
        defaultMessage="The total number of posts with your lens to Spotlight, Private Stories, and/or Public Stories."
    />
);
TotalPostsTooltip.displayName = "TotalPostsTooltip";

export const PostsContentName = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.postsContentName"
        description="Posts content name."
        defaultMessage="Posts"
    />
);
PostsContentName.displayName = "PostsContentName";

export const TotalUniquePosters = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.totalUniquePosters"
        description="Total unique posters."
        defaultMessage="Total Unique Posters"
    />
);
TotalUniquePosters.displayName = "TotalUniquePosters";

export const TotalUniquePostersTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.totalUniquePostersTooltip"
        description="Total unique posters tooltip."
        defaultMessage="The number of unique users who have submitted a post with your lens to Spotlight, Private Stories, and/or Public Stories."
    />
);
TotalUniquePostersTooltip.displayName = "TotalUniquePostersTooltip";

export const PostersContentName = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.engagementTab.postersContentName"
        description="Posters content name."
        defaultMessage="Posters"
    />
);
PostersContentName.displayName = "PostersContentName";
